import {
  Header,
  OpenUrlTarget,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';

import {useSelector} from 'Provider';

import React, {useMemo} from 'react';

import {NavItems} from 'models/AuthenticatedNavItems';
import {LinkData} from 'models/Navigation';
import {navigationLinksSelector} from 'store/content/content.selectors';
import {navigateOrOpenUrl} from 'utils/navigation';
import {getLinkData} from 'utils/navigation';

const ConnectedMyRewardsDesktopHeader: React.FunctionComponent = () => {
  const isAuthenticated = useWidgetState(
    Selectors.isLoggedInSelector
  ) as boolean;
  const links = useSelector(navigationLinksSelector);

  const linkPressed = (link: LinkData) => {
    const {newRewardsScreen, url, title} = link;
    const openNewTab = title.toUpperCase() === 'PROMOTIONS';
    const target = openNewTab ? OpenUrlTarget.BLANK : OpenUrlTarget.SELF;
    navigateOrOpenUrl({
      target,
      legacyUrl: url,
      newRewardsScreen,
    });
  };

  const formattedLinks = useMemo(() => {
    const baseLinks = isAuthenticated ? NavItems : links;
    return baseLinks.map(navItem => getLinkData(navItem.title, navItem.url));
  }, [isAuthenticated, links]);

  return <Header links={formattedLinks} onLinkPressed={linkPressed} />;
};

export default ConnectedMyRewardsDesktopHeader;
